<template>
    <div>
        <table v-for="outright in outrights" style="margin-bottom:20px;" class="table">
            <tr>
                <th width="350">
                    {{ outright.name }} 
                    <br> 
                    <span v-if="outright.start_date">Start date: {{ outright.start_date }}</span>
                    <span v-if="outright.end_date">End date: {{ outright.end_date }}</span>
                </th>
            </tr>
            <tr v-for="competitor in outright.competitors">
                <td>{{ competitor.name }} <span v-if="competitor.abbreviation">({{ competitor.abbreviation }})</span></td>

                <td v-for="book in competitor.books">
                    {{ book.name }} 
                    <span v-if="book.odds">- {{ book.odds }}</span>
                    <span v-if="book.removed">- Removed</span>
                </td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'OutrightsTable',
    props: {
        outrights: ''
    }
}
</script>

